import { Box, Button, Link, styled, Typography, useTheme } from '@mui/material';
import { useSelector } from 'react-redux';

import { ENV, EXTERNAL_LINKS, STRINGS } from '../../../constants';
import useBreakpoint from '../../../hooks/useBreakpoint';
import configSlice from '../../../redux/configSlice';

const StyledBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
});

const InitialSection = () => {
  const isSmallScreen = useBreakpoint('md');
  const theme = useTheme();

  const { appleStoreDpdApp, googleStoreDpdApp } = useSelector(
    configSlice.selectors.getLinksConfig
  );

  return (
    <StyledBox
      sx={{
        flexGrow: 1,
        backgroundColor: theme.vars.palette.primary.backgroundLightGray,
        p: 2,
      }}
    >
      <Box
        component='img'
        src={`${ENV.CDN_BASE_URL_IMAGES}/trackImg.png`}
        alt={'Girl with phone'}
        sx={{ width: { xs: '100%', md: 346 } }}
      />
      <Box sx={{ maxWidth: 400, mt: 3 }}>
        <Typography variant='h2' sx={{ textAlign: 'center', mb: 2 }}>
          {STRINGS.DID_YOU_KNOW}
        </Typography>
        <Typography variant='body1' sx={{ textAlign: 'center', mb: 2 }}>
          {STRINGS.CUSTOMIZE_APP_TEXT}
        </Typography>
        <Typography variant='body1' sx={{ textAlign: 'center' }}>
          {STRINGS.DOWNLOAD_APP_TEXT.DOWNLOAD_TODAY}
          <Link
            href={EXTERNAL_LINKS.APPLE_APP_STORE_URL}
            underline='none'
            target='_blank'
            sx={{ display: 'inline' }}
          >
            {STRINGS.DOWNLOAD_APP_TEXT.APPLE}
          </Link>
          {STRINGS.DOWNLOAD_APP_TEXT.OR}
          <Link
            href={EXTERNAL_LINKS.GOOGLE_PLAY_STORE_URL}
            underline='none'
            target='_blank'
            sx={{ display: 'inline' }}
          >
            {STRINGS.DOWNLOAD_APP_TEXT.GOOGLE}
          </Link>
        </Typography>
      </Box>
      {isSmallScreen && (
        <StyledBox
          sx={{
            gap: 1,
            mt: 3,
            mb: 4,
            width: '100%',
          }}
        >
          <Button
            variant='contained'
            color='primary'
            target='_blank'
            href={appleStoreDpdApp}
            sx={{ width: '100%' }}
          >
            {STRINGS.DOWNLOAD_ON_APPLE}
          </Button>
          <Button
            variant='contained'
            color='primary'
            target='_blank'
            href={googleStoreDpdApp}
            sx={{ width: '100%' }}
          >
            {STRINGS.DOWNLOAD_ON_GOOGLE}
          </Button>
        </StyledBox>
      )}
    </StyledBox>
  );
};

export default InitialSection;
